import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementMeeting } from '../models/get-engagement-conference';
import { PostEngagementConferenceContract } from '../models/post-engagement-conference-contract';

export const AddEngagementConference = createAsyncThunk(
    'engagementMeetings/add',
    async (
        {
            engagementId,
            contract,
        }: { engagementId: number; contract: PostEngagementConferenceContract },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${engagementId}/EngagementMeetings`,
                contract
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not create engagement meeting.',
                    'error'
                );
                throw new Error('Failed to create engagement meeting');
            }

            createNotification(
                'Engagement meeting created successfully.',
                'success'
            );
            return response.data as EngagementMeeting;
        } catch (error) {
            createNotification(
                'An error occurred while creating engagement meeting.',
                'error'
            );
            throw error;
        }
    }
);

